export default __webpack_public_path__ + "static/media/pill.0e652971.png";